import isString from 'lodash/isString'

const prepareLongFileName = (fileName) => {
  if (!isString(fileName)) {
    throw new Error(`FileName: ${fileName} must be a string`)
  }

  const fileNameMaxLength = 50
  const result = fileName.replace(/\s/, ' ').replace(/\.{2,}/, '.')

  if (fileName.length >= fileNameMaxLength) {
    const name = result.split('. ').shift()

    if (name === result) {
      return result
    }

    const extension = result.split('.').pop()

    return `${name}.${extension}`
  }

  return result
}

export default prepareLongFileName
